import gql from "graphql-tag";

export default gql`
  query YoutubePlaylistById($playlistId: ID!) {
    youtubePlaylistById(playlistId: $playlistId) {
      id
      position
      url
      video {
        id
        title
        publishedAt
        chapters {
          slug
          title
          url
          start
          end
          durationInSeconds
        }
        duration {
          hours
          minutes
          seconds
        }
        durationInSeconds
        statistics {
          viewCount
        }
        thumbnails {
          default {
            url
          }
        }
      }
    }
  }
`;
